module.exports = "/work-site/img/safe_work.53af48c8.png";